import React, { PureComponent } from 'react'

export default class planes extends PureComponent {
  render() {
    return (
      <section className="section__container price__container" id="planes" style={{ scrollMarginTop: '100px' }}>
        
        <h2 className="section__header">
          <span style={{ color: 'orange' }}>PLANES</span> DE PAGO
        </h2>

        <p className="section__subheader">
          Trabajamos de forma personalizada con cada cliente, teniendo en cuenta los resultados de la
          estrategias y las valoraciones
        </p>

        <p className="section__subheader2" style={{ color: 'orange' }}>
          Tus clientes son los nuestros.
        </p>

        <div className="price__grid">

          {/* PACK BÁSICO */}
          <div className="price__card">
            <h4 className="price__category">REDES SOCIALES</h4>
            <div className="price__card__content">
              <h3>PACK BÁSICO</h3>

              <p><i className="ri-checkbox-circle-line"></i> HASTA 2 PLATAFORMAS SOCIALES A GESTIONAR</p>
              <p><i className="ri-checkbox-circle-line"></i> DISEÑO DE ESTRATEGIA DE CONTENIDO</p>
              <p><i className="ri-checkbox-circle-line"></i> FRECUENCIA MEDIA DE PUBLICACIONES:</p>
              <p><i className="ri-checkbox-blank-circle-line"></i> 2 - 3 POST (SEMANA)</p>
              <p><i className="ri-checkbox-blank-circle-line"></i> 2 - 3 HISTORIAS (SEMANA)</p>
              <p><i className="ri-checkbox-circle-line"></i> INFORME DE CONTENIDO MENSUAL</p>

            </div>
          </div>

          {/* PACK PREMIUM */}
          <div className="price__card2">
            <h4 className="price__category">REDES SOCIALES</h4>
            <div className="price__card__content2">
              <h3>PACK PREMIUM</h3>

              <p><i className="ri-checkbox-circle-line" style={{ color: 'black' }}></i> DESDE 2 PLATAFORMAS SOCIALES A GESTIONAR</p>
              <p><i className="ri-checkbox-circle-line" style={{ color: 'black' }}></i> DISEÑO DE ESTRATEGIA DE CONTENIDO</p>
              <p><i className="ri-checkbox-circle-line" style={{ color: 'black' }}></i> FRECUENCIA DE PUBLICACIONES:</p>
              <p><i className="ri-checkbox-blank-circle-line" style={{ color: 'black' }}></i> 5 - 7 POST (SEMANA)</p>
              <p><i className="ri-checkbox-blank-circle-line" style={{ color: 'black' }}></i> 5 - 7 HISTORIAS (SEMANA)</p>
              <p><i className="ri-checkbox-circle-line" style={{ color: 'black' }}></i> PUBLICACIONES FECHAS ESPECIALES</p>
              <p><i className="ri-checkbox-circle-line" style={{ color: 'black' }}></i> INFORME DE CONTENIDO MENSUAL</p>

            </div>
          </div>

          {/* PUBLICIDAD - PANTALLA LED */}
          <div className="price__card">
            <h4 className="price__category">PUBLICIDAD</h4>
            <div className="price__card__content">
              <h3>PANTALLA LED</h3>

              <p><i className="ri-tv-2-line"></i> DIMENSIONES DE LA PANTALLA: 1m x 4m</p>
              <p><i className="ri-slideshow-line"></i> RESOLUCIÓN: FULL HD</p>
              <p><i className="ri-video-line"></i> FORMATO DE VIDEO: MP4</p>
              <p><i className="ri-time-line"></i> DURACIÓN IDEAL DEL SPOT: 20 SEGUNDOS (MÁX. 25 SEGUNDOS)</p>

            </div>
          </div>

        </div>

        <div className="containerSolicitaPresupuesto">
          <button
            className="btn_solicitaPresupuesto"
            onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
          >
            ¡SOLICITA TU PRESUPUESTO!
          </button>
        </div>

      </section>
    )
  }
}
